<template>
  <div>
    <div class="blueBanner">
        <v-container fluid>
            <v-layout align-center column justify-center>
                <v-flex xs12 align-center text-lg-center>
                <h1 class="display-2 mt-0 metropolisBold font-weight-bold pb-4">Most Affordable Web Development Around. Guaranteed.</h1>
                <p class="mb-0 headline metropolisMedium pb-4">
                  If you find a price better than ours, we’ll beat it and throw <br>in some free hours of work to prove
                  we want your business. </p>

               <router-link to="#contact-form-header" @click.native="scrollTo('#contact-form-header')">
                  <v-btn flat class="white--text consultationButton metropolisSemiBold pt-2 pb-2 pr-4 pl-4">Consultation</v-btn>
                </router-link>
                </v-flex>
                
            </v-layout>
        </v-container>
        
    </div>
    
    <v-container mt-4>
      <v-layout>
        <v-flex>
          <h2 class="display-2 mt-0 metropolisBold textCenter">Affordable and Flexible Pricing</h2>
          <div class="headline metropolisMedium textCenter">We will go out of our way to meet your specific needs and budgets.</div>
        </v-flex>
      </v-layout>
    </v-container>

    
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap fill-height align-center justify-center>
        <v-flex md6 xs12>
          <div class="metropolisBold display-2 mt-0">
          <span class="">Starting at</span> <br>
          <span>$25 per hour</span>
          </div>
        </v-flex>
        <v-flex md6 xs12 >
          <v-img src="assets/images/pricingFeaturedImage.jpg" max-width="388"></v-img>
        </v-flex>
      </v-layout>
    </v-container>
    
    
    <v-container>
      <v-layout row wrap fill-height justify-center>
        <v-flex md6 xs12>
          <v-container>
            <v-layout>
              <v-flex >
                <v-img src="https://ik.imagekit.io/canvasdev/quality_5QNWExjC6p.svg" width="45" class="mx-3"></v-img>
              </v-flex>
              <v-flex class="pl-1">
                <div class="pt-2 title metropolisBold mb-3">Quality</div>
                <div class="grey--text text--darken-1">All development is done through version control, verfied in a staging environment & approved before published live.</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex md6 xs12>
          <v-container>
            <v-layout>
              <v-flex class="pl-2">
                <v-img src="https://ik.imagekit.io/canvasdev/service2_aDdtXmC9c.svg" width="40" class="mx-3"></v-img>
              </v-flex>
              <v-flex>
                <div class="pt-2 title metropolisBold mb-3">Service</div>
                <div class="grey--text text--darken-1">We engange very closely with our clients. You can contact us by phone, email or through live skype chat. Talk directly to your developer & team members working on the project. No middle-man in between.</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>

  
    <v-container>
      <v-layout row wrap fill-height justify-center>
        <v-flex md6 xs12>
          <v-container>
            <v-layout>
              <v-flex class="pl-2">
                <v-img src="https://ik.imagekit.io/canvasdev/turnaround_ywACPu-sq.svg" width="40" class="mx-3"></v-img>
              </v-flex>
              <v-flex>
                <div class="pt-2 title metropolisBold mb-3">Fast Turnaround Time</div>
                <div class="grey--text text--darken-1">We have team members based around the world and we make progress on your projects around the clock.</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex md6 xs12>
          <v-container>
            <v-layout>
              <v-flex class="pl-3">
                <v-img src="https://ik.imagekit.io/canvasdev/pricing2_ofS0Xpepm.svg" width="20" class="mx-3"></v-img>
              </v-flex>
              <v-flex class="pl-2 pb-3">
                <div class="pt-2 title metropolisBold mb-3">Transparent Pricing</div>
                <div class="grey--text text--darken-1">We provide you with full visibility into all of our tools and systems, with down-to-the-hour detail on where your money is being spent and why.</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  
    <!-- <v-container>
      <v-layout wrap align-end justify-center row fill-height text-xs-center>
        <v-flex md3 xs6 v-for="(review, i) in reviews" :key="i" :name="review.name">
          <img :src="`assets/images/`+review.img"><br>
          {{review.score}}
        </v-flex>
      </v-layout>
    </v-container> -->
    
  </div> 
</template>

<script>

const TIMEOUT = 1;

export default {
  name: "Pricing",
  metaInfo: {
      title: 'Pricing | Canvas Development', 
      meta: [
          {                 
            name: 'keywords',
            content: 'pricing'
          },
          {
            name: 'description',
            content:'If you find a price better than ours, we’ll beat it and throw in some free hours of work to prove we want your business.'
          }
      ]
      
    },
  data(){
    return{
      reviews:[
        {
          name: 'clutch',
          img:'PricingRatingClutch.jpg',
          score: '4.9/5.0'
        },
        {
          name: 'good-firms',
          img:'PricingRatingGoodFirm.jpg',
          score: '4.9/5.0'
        },
        {
          name: 'google',
          img:'PricingRatingGoogle.jpg',
          score: '5.0/5.0'
        },
        {
          name: 'facebook',
          img:'PricingRatingFacebook.jpg',
          score: '5.0/5.0'
        }
      ]
    }
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, TIMEOUT)
    }
  },
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT)
    }
  }
};
</script>

<style scoped>
.category-links a {
  text-transform: uppercase;
  display: inline-block;
  margin-right: 50px;
}

.router-link-exact-active {
  font-weight: 700;
  text-decoration: underline;
  color: #ba68c8;
}

.blueBanner {
  background: rgba(48, 48, 137) url("https://ik.imagekit.io/canvasdev/pricing-header-banner_NtuHNWaLT.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  padding: 200px 0;
  color: #fff;
}

.consultationButton{
    border:1px solid #FFF;
    font-size:20px;
    height:inherit;

}

@media only screen and (max-width:767px){
  .blueBanner{
    padding:20px 0;
  }   
}


</style>

